<script setup lang="ts">
interface Props {
  color?: string;
}

const props = withDefaults(defineProps<Props>(), {
  color: '#e8e8ea',
});
</script>

<template>
  <div
    class="p-timeline-event-connector"
    :style="{ '--connector-color': props.color }"
  ></div>
</template>

<style scoped>
.p-timeline-event-connector {
  border: 1px solid var(--connector-color) !important;
  margin: 6px 0;
  background-color: var(--connector-color) !important;
}
</style>
